import { DataTransform } from '../dataTransform';
import { TransformRule } from '../transformRule';
import { TransformType } from '../transformType';
import { DataFarmType } from '../dataFarmType';
import { SortInfo } from '../sortInfo';

export class EventNamerTransform extends DataTransform<EventNamerTransformConfig> {

    constructor(id: number, index: number, name: string,nodeID:string) {
      super(id, name, index, TransformType.eventNamer,nodeID);
      this.transformConfig = new EventNamerTransformConfig();
    }

    static fromJSON(data: any): EventNamerTransform {
        //console.log(`fromJson invoked: ${data}`);
        const instance: EventNamerTransform = Object.assign(new EventNamerTransform(0, 0, '', ''), data);
        instance.transformConfig = EventNamerTransformConfig.fromJSON(instance.transformConfig);

        return instance;
    }
    
    setRunAll(runAll: boolean): void {
        this.transformConfig.runAll = runAll;
    }
}

export class EventNamerTransformConfig {
    transformConfigId?: number;
    instance: string;
    farmType: DataFarmType;
    transformType: TransformType;
    defSourceField: string;
    defTargetField: string;
    sortInfo?: SortInfo[];
    includeInResults?:string[];
    userField: string;
    timestampField: string;
    sampleStart: number;
    sampleEnd: number;
    defTimeout: number;
    runAll: boolean;
    missesNamed: string;
    delMisses: boolean;
    //bufferRows: number;
    threads: number;
    multiColumnTarget: boolean;
    spaceSeparator = false;
    removeRedundant = false;
    groupBy: string;
    addFields: string[];
    rules: EventNamerTransformRule[];
    searchWildCard: string;

    static fromJSON(data: any): EventNamerTransformConfig {
        //console.log(`fromJson invoked: ${data}`);
        const instance: EventNamerTransformConfig = Object.assign(new EventNamerTransformConfig(), data);

        const rules: EventNamerTransformRule[] = [];

        if (instance.rules) {
            instance.rules.forEach(r => {
                const rule = EventNamerTransformRule.fromJSON(r);
                rules.push(rule);
            });
        }
        instance.rules = rules;
        return instance;
    }
}

export class EventNamerTransformRule extends TransformRule {
    sourceField: string;
    targetField: string;
    actionString?: string[];
    objectString?: string[];
    includeAction: boolean;
    ignoreSpaces = false;
    matchCase = false;

    static fromJSON(data: any): EventNamerTransformRule {
        //console.log(`fromJson invoked: ${data}`);
        const instance: EventNamerTransformRule = Object.assign(new EventNamerTransformRule(), data);

        return instance;
    }
}